<template>
    <div class="top-bar">
        <div class="left-part">
            <router-link to="/"><img src="../../../static/img/logo-white-80x35.png"></router-link>
            <div>- managed cloud network</div>

        </div>
        <div class="right-part">
            <span class="user-email">{{ userEmail }}</span>

            <el-popover
                v-if="displayTakerName"
                ref="change-taker"
                placement="bottom"
                width="148"
                trigger="click"
                popper-class="dark-popper"
                @hide="hidePopover"
            >
                <div>
                    <div class="popover-title">Do you want to change the taker to impersonate ?</div>
                    <div class="actions">
                        <el-button type="text" class="decline" @click="hidePopover">No</el-button>
                        <el-button type="text" class="accept" @click="changeTaker">Yes</el-button>
                    </div>
                </div>
                <span
                    slot="reference"
                    class="current-taker"
                >{{ $store.state.currentTaker.name }}</span>
            </el-popover>

            <router-link to="/manage-profile" style="margin-right: 10px;">
                <el-button class="gmcn-btn-icon" icon="el-icon-user" circle></el-button>
            </router-link>
            <el-popover
                placement="bottom"
                width="200"
                trigger="hover"
                popper-class="dark-popper"
                :disabled="$store.getters.currentTaker !== null && $store.getters.currentEntity !== null"
            >
                <div>
                    <div class="popover-title" style="margin-bottom: 10px;">You must choose an entity and a taker before accessing settings view</div>
                </div>
                <span slot="reference" popper-class="setting-btn-wrapper" style="margin-right: 10px;">
                    <el-button
                        class="gmcn-btn-icon"
                        icon="el-icon-setting"
                        circle
                        :disabled="$store.getters.currentTaker === null || $store.getters.currentEntity === null"
                        @click="$router.push('/settings')"
                    ></el-button>
                </span>
            </el-popover>
            <el-button
                class="gmcn-btn-icon"
                icon="el-icon-switch-button"
                circle
                @click="loggout"
            ></el-button>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {
        userEmail (){
            return this.$store.getters.currentUser.email;
        },
        displayTakerName (){
            return this.$store.getters.takers.length > 1 && this.$store.state.currentTaker !== null;
        },

    },

    mounted (){

    },

    methods: {
        loggout (){
            this.$store.dispatch('logoutUser');
        },

        hidePopover() {
            if (this.$refs['change-taker']) {
                this.$refs['change-taker'].showPopper = false;
            }
        },
        changeTaker (){
            this.$router.push('/select-taker');
        },
    },
};
</script>

<style lang="scss">
    .top-bar{
        position: fixed;
        height: 50px;
        width: 100%;
        background-color: #222223;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 20px;
        z-index: 2;
        .left-part{
            font-family: Roboto;
            font-size: 14px;
            text-transform: uppercase;
            display: flex;
            align-items: center;
        }
        .user-email{
            margin-right: 15px;
        }
        .user-email{
            margin-right: 15px;
        }
        .current-taker{
            margin-right: 15px;
            cursor: pointer;
            text-decoration: underline;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/top-bar.vue